import { render, staticRenderFns } from "./ActionBtn.vue?vue&type=template&id=ef33e52e&scoped=true"
import script from "./ActionBtn.vue?vue&type=script&lang=js"
export * from "./ActionBtn.vue?vue&type=script&lang=js"
import style0 from "./ActionBtn.vue?vue&type=style&index=0&id=ef33e52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef33e52e",
  null
  
)

export default component.exports